import { useCallback } from "react";

import { useSnackbar } from "notistack";

function useSnackbarMessage() {
  const { enqueueSnackbar } = useSnackbar();

  const raiseErrorSnackbar = useCallback(
    (message) => {
      enqueueSnackbar(message, {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "center",
        },
      });
    },
    [enqueueSnackbar]
  );

  const raiseWarningSnackbar = useCallback(
    (message) => {
      enqueueSnackbar(message, {
        variant: "warning",
        anchorOrigin: {
          vertical: "top",
          horizontal: "center",
        },
      });
    },
    [enqueueSnackbar]
  );

  const raiseSuccessSnackbar = useCallback(
    (message) => {
      enqueueSnackbar(message, {
        variant: "success",
        anchorOrigin: {
          vertical: "top",
          horizontal: "center",
        },
      });
    },
    [enqueueSnackbar]
  );

  return {
    raiseErrorSnackbar,
    raiseSuccessSnackbar,
    raiseWarningSnackbar,
  };
}

export { useSnackbarMessage };
